// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { CustomError } from "@lib/utilities/CustomError";

/**
 * Thrown when an argument provided to a method is not valid.
 */
export class ArgumentError extends CustomError
{
  readonly parameterName: string;

  constructor(message: string, parameterName: string)
  {
    super(`${message}\r\nParameter name: '${parameterName}'`, "ArgumentError");

    this.parameterName = parameterName;
  }
}